import NumberFormatter from '../../components/Grid/NumberFormatter';
import CurrencyFormatter from '../../components/Grid/CurrencyFormatter';
import SemaforoFormatter from './SemaforoFormatter';
import CurrencySummary from '../../components/Grid/CurrencySummary';
import CustomerSummary from './CustomerSummary'

export default [
  {
    key: 'route',
    name: 'R',
    type: 'number',
    resizable: false,
    filterable: true,
    sortable: true,
    frozen: true,
    width: 35,
    formatter: NumberFormatter
  },
  // Coluna Comentada, retirada por hora, mas deixada caso queiram de volta
  // {
  //   key: 'suggestionPriority',
  //   name: 'PS',
  //   type: 'number',
  //   resizable: false,
  //   filterable: true,
  //   sortable: true,
  //   frozen: true,
  //   width: 40,
  //   formatter: NumberFormatter
  // },
  {
    key: 'financialFlag',
    // name: 'Fin',
    resizable: false,
    filterable: true,
    sortable: true,
    frozen: true,
    width: 25,
    formatter: SemaforoFormatter,
  },
  {
    key: 'salePotential',
    name: 'Pot. Ven.',
    type: 'number',
    resizable: false,
    filterable: true,
    sortable: true,
    frozen: true,
    width: 100,
    formatter: CurrencyFormatter,
    summary: CurrencySummary
  },
  {
    key: 'name',
    name: 'Cliente',
    type: 'text',
    resizable: false,
    filterable: true,
    sortable: true,
    frozen: true,
    width: 150,
    summary: CustomerSummary
  },
  // {
  //   key: 'register',
  //   name: 'CNPJ',
  //   type: 'text',
  //   resizable: false,
  //   filterable: false,
  //   sortable: false,
  //   frozen: true,
  //   width: 110,
  // },
  {
    key: 'economicGroup',
    name: 'G. Econ.',
    type: 'text',
    resizable: false,
    filterable: true,
    sortable: true,
    frozen: true,
    width: 80,
  },
  {
    key: 'city',
    name: 'Cidade',
    type: 'text',
    resizable: false,
    filterable: true,
    sortable: true,
    frozen: true,
    width: 100,
  },
];
